import React from 'react';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-[#1e3d25] py-8 text-center border-t border-white/10" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4" data-id="element-34">
        <p className="text-white/40 text-sm font-medium tracking-wide" data-id="element-35">
          &copy; {year} El Manual del Jardinero. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}